import { render } from "./Tablelist.vue?vue&type=template&id=20b4657c&scoped=true"
import script from "./Tablelist.vue?vue&type=script&lang=js"
export * from "./Tablelist.vue?vue&type=script&lang=js"

import "./Tablelist.vue?vue&type=style&index=0&id=20b4657c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20b4657c"]])

export default __exports__